export class CardDto {
  id: string = '';
  deviceId: string = '';
  number: string = '';
  status: string = '';
  classify: string = '';
  remarks: string = '';
}
